module.exports = __webpack_public_path__ + "static/media/user-avatar.c09fa739.svg";